"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
Object.defineProperty(exports, "__esModule", { value: true });
var coreutils_1 = require("@jupyterlab/coreutils");
var serverconnection_1 = require("../serverconnection");
/**
 * The url for the lab workspaces service.
 */
var SERVICE_WORKSPACES_URL = 'api/workspaces';
/**
 * The workspaces API service manager.
 */
var WorkspaceManager = /** @class */ (function () {
    /**
     * Create a new workspace manager.
     */
    function WorkspaceManager(options) {
        if (options === void 0) { options = {}; }
        this.serverSettings = options.serverSettings ||
            serverconnection_1.ServerConnection.makeSettings();
    }
    /**
     * Fetch a workspace.
     *
     * @param id - The workspaces's ID.
     *
     * @returns A promise that resolves with the workspace or rejects with a
     * `ServerConnection.IError`.
     */
    WorkspaceManager.prototype.fetch = function (id) {
        var serverSettings = this.serverSettings;
        var baseUrl = serverSettings.baseUrl, pageUrl = serverSettings.pageUrl;
        var base = baseUrl + pageUrl;
        var url = Private.url(base, id);
        var promise = serverconnection_1.ServerConnection.makeRequest(url, {}, serverSettings);
        return promise.then(function (response) {
            if (response.status !== 200) {
                throw new serverconnection_1.ServerConnection.ResponseError(response);
            }
            return response.json();
        });
    };
    /**
     * Save a workspace.
     *
     * @param id - The workspace's ID.
     *
     * @param workspace - The workspace being saved.
     *
     * @returns A promise that resolves when saving is complete or rejects with
     * a `ServerConnection.IError`.
     */
    WorkspaceManager.prototype.save = function (id, workspace) {
        var serverSettings = this.serverSettings;
        var baseUrl = serverSettings.baseUrl, pageUrl = serverSettings.pageUrl;
        var base = baseUrl + pageUrl;
        var url = Private.url(base, id);
        var init = {
            body: JSON.stringify(workspace),
            method: 'PUT'
        };
        var promise = serverconnection_1.ServerConnection.makeRequest(url, init, serverSettings);
        return promise.then(function (response) {
            if (response.status !== 204) {
                throw new serverconnection_1.ServerConnection.ResponseError(response);
            }
            return undefined;
        });
    };
    return WorkspaceManager;
}());
exports.WorkspaceManager = WorkspaceManager;
/**
 * A namespace for private data.
 */
var Private;
(function (Private) {
    /**
     * Get the url for a workspace.
     */
    function url(base, id) {
        return coreutils_1.URLExt.join(base, SERVICE_WORKSPACES_URL, id);
    }
    Private.url = url;
})(Private || (Private = {}));
